import React from 'react';
// import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';

import styles from './Pagination.module.scss'; 

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // If there are less than 2 times in pagination range we shall not render the component
    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    // const onNext = () => {
    //     onPageChange(currentPage + 1);
    // };
    const onNext = () => {
        if (currentPage < paginationRange[paginationRange.length - 1]) {
            onPageChange(currentPage + 1);
        } else {
            onPageChange(1); // Loop to the first page
        }
    };

    // const onPrevious = () => {
    //     onPageChange(currentPage - 1);
    // };
    const onPrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        } else {
            onPageChange(paginationRange[paginationRange.length - 1]); // Loop to the last page
        }
    };

    // let lastPage = paginationRange[paginationRange.length - 1];

    return (
        <ul className={`${styles.paginationContainer}`}>
            <li
                className={`${styles.paginationItem}`}
                onClick={onPrevious}
            >
                <div className={`${styles.arrow} ${styles.left}`} />
            </li>
    
            {paginationRange.map(pageNumber => {
                if (pageNumber === DOTS) {
                    return <li className={`${styles.paginationItem} ${styles.dots}`}>&#8230;</li>;
                }
    
                return (
                    <li
                        className={`${styles.paginationItem} ${pageNumber === currentPage ? styles.active : ''}`}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </li>
                );
            })}
    
            <li
                className={`${styles.paginationItem}`}
                onClick={onNext}
            >
                <div className={`${styles.arrow} ${styles.right}`} />
            </li>
        </ul>
    );
};

export default Pagination;